import React, { memo } from 'react';
import styled from 'styled-components';
import Skeleton from 'base/components/Skeleton';
import Repeat from 'base/components/Repeat';
import LargeLabel from 'base/components/LargeLabel';
import Teaser from 'base/components/Teaser';
import theme from '../../theme';

const Abstract = styled.p`
  margin: 0.5rem 0 0 0;
  font-size: ${theme.fontSizes.default};
`;

const NewsSkeleton = () => (
  <Repeat
    times={5}
    render={(i) => (
      <Teaser.Wrapper key={i}>
        <Teaser.MainCol style={{ width: '100%' }}>
          <Skeleton width="80px" height="10px" />
          <LargeLabel><Skeleton width="70%" /></LargeLabel>
          <Abstract><Skeleton width="80%" height="10px" count={3} /></Abstract>
        </Teaser.MainCol>
      </Teaser.Wrapper>
    )}
  />
);

export default memo(NewsSkeleton);
